import { RaiSsoProfile } from './profile.js';

const ACCESS_TOKEN = 'rai:access_token';
const REFRESH_TOKEN = 'rai:refresh_token';
const ACCESS_TOKEN_LAST_DATE = 'rai:access_token_last_date';
const RAISSO_COOKIE = 'rai:raiSso';
const RAISSO_CHILDREN_PROFILE_COOKIE = 'rai:raiSsoChildrenProfiles';
const RAISSO_DEVICE_APPID = 'rai:device_app_id';

interface TokenObject {
  authToken: string;
  refreshToken: string;
}

class LocalStorageService {

  private static instance: LocalStorageService;

  public static getService() {
    if (!this.instance) {
      this.instance = new LocalStorageService();
    }
    return this.instance;
  }

  public setToken(tokens: TokenObject) {
    const { authToken, refreshToken } = tokens;
    localStorage.setItem(ACCESS_TOKEN, authToken);
    localStorage.setItem(REFRESH_TOKEN, refreshToken);
    document.cookie = `${ACCESS_TOKEN}=${encodeURIComponent(authToken)};  expires=Fri, 31 Dec 2199 23:59:59 GMT; path=/; secure; SameSite=Strict`;
    document.cookie = `${REFRESH_TOKEN}=${encodeURIComponent(refreshToken)};  expires=Fri, 31 Dec 2199 23:59:59 GMT; path=/; secure; SameSite=Strict`;
  }

  public getAccessToken() {
    try {
      return localStorage.getItem(ACCESS_TOKEN);
    } catch (e) {
      return undefined;
    }
  }

  public getRefreshToken() {
    try {
      return localStorage.getItem(REFRESH_TOKEN);
    } catch (e) {
      return undefined;
    }
  }

  public clearToken() {
    localStorage.removeItem(ACCESS_TOKEN);
    localStorage.removeItem(REFRESH_TOKEN);
    this.deleteCookie(ACCESS_TOKEN);
    this.deleteCookie(REFRESH_TOKEN);
  }

  public deleteCookie(name:string) {
    document.cookie = `${name}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT; SameSite=Strict`;
}

  public setProfile(profile?: RaiSsoProfile, childrenProfile?: unknown) {
    if (profile) {
      const p = JSON.stringify(profile);
      localStorage.setItem(RAISSO_COOKIE, p);
    }
    if (childrenProfile) { localStorage.setItem(RAISSO_CHILDREN_PROFILE_COOKIE, JSON.stringify(childrenProfile)) }
  }

  public getProfile(): RaiSsoProfile | undefined {
    try {
      const profile = localStorage.getItem(RAISSO_COOKIE);
      if (profile) {
        const p = JSON.parse(profile);
        return RaiSsoProfile.fromJSON(p);
      }
    } catch (e) {
      //empty
    }
    return undefined;
  }

  public getChildrenProfile(): unknown {
    const childrenProfile = localStorage.getItem(RAISSO_CHILDREN_PROFILE_COOKIE);
    return (childrenProfile && JSON.parse(childrenProfile)) || undefined;
  }

  public clearProfile() {
    localStorage.removeItem(RAISSO_COOKIE);
    localStorage.removeItem(RAISSO_CHILDREN_PROFILE_COOKIE);
  }

  public setTokenLastDate(){
    localStorage.setItem(ACCESS_TOKEN_LAST_DATE, String(Date.now()));
  }

  public getTokenLastDate() {
    try {
      const resp = localStorage.getItem(ACCESS_TOKEN_LAST_DATE);
      return Number(resp);
    } catch (e) {
      return undefined;
    }
  }

  public setDeviceAppId(appId: number) {
    localStorage.setItem(RAISSO_DEVICE_APPID, `${appId}`)
  }

  public getDeviceAppId() {
    const _appId = localStorage.getItem(RAISSO_DEVICE_APPID);
    const appId = Number(_appId);
    return appId;
  }
}

export default LocalStorageService;
